import React from "react";
import { Col, FloatingLabel, Form } from "react-bootstrap";
import { User } from "../../types/user";

interface SelectFamilyState {
  defaultSelection?: string;
  skipDefaultSelection?: boolean;
  family: User[];
  familyUser: any;
  updateFamilyUser: any;
  readOnly?: boolean;
  includeLabel?: boolean;
}

const SelectFamily = ({
  defaultSelection = "Select from List",
  skipDefaultSelection = false,
  family,
  familyUser,
  updateFamilyUser,
  readOnly = false,
  includeLabel = true,
}: SelectFamilyState) => {
  return (
    <>
      {includeLabel ? (
        <Col className="col-6">
          <FloatingLabel controlId="floatingInput" label="Household Member">
            <Form.Select data-testid="household-member" className="decorated" value={familyUser} onChange={(e: any) => updateFamilyUser(e)} disabled={readOnly}>
              {skipDefaultSelection === false && (
                <option value="unassigned">
                  {defaultSelection}
                </option>
              )}
              {family.map((i: any, index: any) => (
                <option key={index} datatype={i.type} value={i.id + "|" + i.type}>
                  {i.name}
                  {i.isDeleted ? "->deleted" : ""}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
        </Col>
      ) : (
        <Form.Select className="decorated" value={familyUser} onChange={(e: any) => updateFamilyUser(e)} disabled={readOnly}>
          {skipDefaultSelection === false && (
            <option value="unassigned">
              {defaultSelection}
            </option>
          )}
          {family.map((i: any, index: any) => (
            <option key={index} datatype={i.type} value={i.id + "|" + i.type}>
              {i.name}
              {i.isDeleted ? "->deleted" : ""}
            </option>
          ))}
        </Form.Select>
      )}
    </>
  );
};

export default SelectFamily;
